import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';

export const TransferValuePerYear = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData?.values?.annual || [];

    const series = [
        {
            name: 'Valor Repassado ',
            data: rawData.map(item => Number(item.value))
        }
    ];

    return (
        <SimpleBars
            title="Valor Repassado - Anual"
            horizontal={false}
            subtitles={rawData.map(item => getYearLabel(item.ano))}
            series={series}
        />
    );
};
